import preval from 'preval.macro';

const buildInfo = preval`
  const { version } = require('../../package.json');
  const { execSync } = require('child_process');
  const os = require('os');
  const crypto = require('crypto');

  const exec = (cmd) => {
    try {
      return execSync(cmd).toString().trim();
    } catch {
      return '';
    }
  };

  const gitInfo = {
    commit: exec('git rev-parse --short HEAD'),
    branch: exec('git rev-parse --abbrev-ref HEAD'),
  };

  const osInfo = {
    platform: os.platform(),
    arch: os.arch(),
    hostname: os.hostname(),
    user: os.userInfo().username,
  };

  const envInfo = {
    nodeVersion: process.version,
    environment: process.env.NODE_ENV || 'unknown',
  };

  const timestamp = new Date().toISOString();

  module.exports = {
    version,
    timestamp,
    gitInfo,
    osInfo,
    envInfo,
  };
`;

export default buildInfo;